import React from 'react'
import { Container, Row, Col } from 'components/qstrap'
import Paper from 'components/atoms/Paper'
import Typography from 'components/atoms/Typography'

const AboutKIT = () => (
  <div id="about-kit" className="about-kit section">
    <Container>
      <Row>
        <Col md="6">
          <Paper className="about-kit__text" rounded>
            <Typography component="p" variant="body">
              <span className="font-weight-bold">Kirirom Institute of Technology Cambodia</span>, menjadi kampus yang bisa membuka jalan untuk mencapai mimpi tersebut, Quipperian. Kampus yang terletak di negara Kamboja ini menyediakan berbagai program beasiswa yang tak boleh dilewatkan. Beasiswa yang diberikan pun tidak tanggung-tanggung, yakni mencapai 31.100 USD atau setara dengan Rp435,4 juta (1 USD=Rp14.000). Dengan jumlah tersebut, kamu seperti kuliah gratis saja!
            </Typography>
            <br/>
            <Typography component="p" variant="body">
              Kamu bisa mendapatkan dua jenis beasiswa, yaitu performance-based scholarship atau sejenis beasiswa prestasi dan sponsorship-based scholarship atau beasiswa dari perusahaan sponsor. Beasiswa ini disediakan untuk Jurusan Software Engineering. So, cocok banget buat kamu yang ingin melanjutkan pendidikan di bidang ini. Cari tahu lebih jauh tentang KIT Cambodia yuk!
            </Typography>
          </Paper>
        </Col>
      </Row>
    </Container>
  </div>
)

export default AboutKIT
